import React, { useState } from "react";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import { NavLink } from "react-router-dom";
import { useClipboard } from "use-clipboard-copy";
import "./digital-passport-info.css";

const convertActiveStepToVerifyRoute = ({
  viewingFishing,
  viewingLanding,
  viewingWeighting,
  viewingAuctioning,
  viewingTransportation,
  viewingCustomClearance,
}) => {
  let route;
  if (viewingFishing) {
    route = "/verify-fishing-landing";
  }
  if (viewingLanding) {
    route = "/verify-fishing-landing";
  }
  if (viewingWeighting) {
    route = "/verify-weighting";
  }
  if (viewingAuctioning) {
    route = "/verify-auctioning";
  }
  if (viewingTransportation) {
    route = "/verify-transportation";
  }
  if (viewingCustomClearance) {
    route = "/verify-custom-clearance";
  }
  return route;
};

const getTxUrlByStep = ({
  viewingFishing,
  viewingLanding,
  viewingWeighting,
  viewingAuctioning,
  viewingTransportation,
  viewingCustomClearance,
}) => {
  if (viewingFishing || viewingLanding)
    return "https://etherscan.io/tx/0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingWeighting)
    return "https://etherscan.io/tx/0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingAuctioning)
    return "https://etherscan.io/tx/0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingTransportation)
    return "https://etherscan.io/tx/0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingCustomClearance)
    return "https://etherscan.io/tx/0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  return "#";
};

const getTxHashByStep = ({
  viewingFishing,
  viewingLanding,
  viewingWeighting,
  viewingAuctioning,
  viewingTransportation,
  viewingCustomClearance,
}) => {
  if (viewingFishing || viewingLanding)
    return "0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingWeighting)
    return "0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingAuctioning)
    return "0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingTransportation)
    return "0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  if (viewingCustomClearance)
    return "0xb0fbc0afb845653fdd4f95b3b31ba16c61cc2ef79b42f6edfc3def89a830aaf5";
  return "";
};

const PassportInfo = (props) => {
  const {
    viewingFishing,
    viewingLanding,
    viewingWeighting,
    viewingAuctioning,
    viewingTransportation,
    viewingCustomClearance,
    viewFishingData,
    viewLandingData,
    viewWeightingData,
    viewAuctioningData,
    viewTransportationData,
    viewCustomClearanceData,
    submittedVesselData,
    submittedLotData,
    submittedSalesNoteData,
    submittedTransportDocData,
    submittedCatchCertificateData,
    submittedHealthCertificateData,
  } = props;
  const [isCopied, setIsCopied] = useState(false);
  const clipboard = useClipboard();

  const onCopy = () => {
    clipboard.copy(
      getTxHashByStep({
        viewingFishing,
        viewingLanding,
        viewingWeighting,
        viewingAuctioning,
        viewingTransportation,
        viewingCustomClearance,
      })
    );
    setIsCopied(true);
    const t = setTimeout(() => {
      setIsCopied(false);
      clearTimeout(t);
    }, 1000);
  };

  return (
    <>
      <div className="flex-col-53">
        <div className="flex-col-54">
          <p className="fish">
            <span className="poppins-semi-bold-bay-of-many-15px">
              Fish species:
            </span>
            <br />
            <span className="poppins-medium-sonic-silver-15px">
              {submittedVesselData ? "Pollack" : "--"}
            </span>{" "}
            <span className="poppins-light-masala-14px">
              {submittedVesselData ? "(Pollachius pollachius)" : ""}
            </span>
          </p>
          <div className="lot-weight-457kg">
            <span className="poppins-semi-bold-bay-of-many-15px">
              Lot weight:
            </span>
            <br />
            <span className="poppins-medium-sonic-silver-15px">
              {submittedVesselData ? "457kg" : "--"}
            </span>
          </div>
        </div>
        <div className="flex-row-8">
          <div className="flex-col-55 poppins-semi-bold-white-16px-2">
            <div className="fish">
              <span className="poppins-semi-bold-bay-of-many-15px">
                Fishery name:
              </span>
              <br />
              <span className="poppins-medium-sonic-silver-15px">
                {submittedVesselData ? "James Miles" : "--"}
              </span>
            </div>
            <div className="pln-boat-0409954-sealess-rock">
              <span className="poppins-semi-bold-bay-of-many-15px">PLN</span>
              <br />
              <span className="poppins-medium-sonic-silver-15px">
                {submittedVesselData ? (
                  <>
                    Boat: 0409954 <br /> Sealess Rock
                  </>
                ) : (
                  "--"
                )}
              </span>
            </div>
          </div>
          {convertActiveStepToVerifyRoute({
            viewingFishing,
            viewingLanding,
            viewingWeighting,
            viewingAuctioning,
            viewingTransportation,
            viewingCustomClearance,
          }) && (
            <NavLink
              to={convertActiveStepToVerifyRoute({
                viewingFishing,
                viewingLanding,
                viewingWeighting,
                viewingAuctioning,
                viewingTransportation,
                viewingCustomClearance,
              })}
              className="group-117"
              target="_blank"
              rel="noopener noreferrer"
            >
              {(viewingFishing || viewingLanding) && (
                <img src="/img/verify_fishing_landing.png" />
              )}
              {viewingWeighting && <img src="/img/verify_weighting.png" />}
              {viewingAuctioning && <img src="/img/verify_auctioning.png" />}
              {viewingTransportation && (
                <img src="/img/verify_transportation.png" />
              )}
              {viewingCustomClearance && (
                <img src="/img/verify_custom_clearance.png" />
              )}
            </NavLink>
          )}
        </div>
        {(viewingFishing ||
          viewingLanding ||
          viewingWeighting ||
          viewingAuctioning ||
          viewingTransportation ||
          viewingCustomClearance) && (
          <div className="passport-transaction-fields">
            <div className="transaction-id-field">
              <div className="poppins-semi-bold-bay-of-many-15px transaction-id-field-label">
                <span>Transaction hash</span>
                <Tooltip
                  title={
                    <span className="poppins-normal-white-12px">Copied</span>
                  }
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  placement="top"
                  arrow
                  open={isCopied}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={onCopy}
                    className="hash-tooltip"
                  >
                    <circle cx="11" cy="11" r="11" fill="#21427D" />
                    <path
                      d="M11.5608 5.3877H7.63221C7.33452 5.3877 7.04902 5.50595 6.83852 5.71645C6.62802 5.92695 6.50977 6.21245 6.50977 6.51014V15.4897C6.50977 15.7874 6.62802 16.0729 6.83852 16.2834C7.04902 16.4939 7.33452 16.6122 7.63221 16.6122H14.3669C14.6646 16.6122 14.9501 16.4939 15.1606 16.2834C15.3711 16.0729 15.4894 15.7874 15.4894 15.4897V9.31627M11.5608 5.3877L15.4894 9.31627M11.5608 5.3877V9.31627H15.4894"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Tooltip>
              </div>
              <span className="poppins-medium-sonic-silver-9px transaction-id-field-value">
                {getTxHashByStep({
                  viewingFishing,
                  viewingLanding,
                  viewingWeighting,
                  viewingAuctioning,
                  viewingTransportation,
                  viewingCustomClearance,
                })}
              </span>
            </div>
            <a
              className="transaction-url-field"
              href={getTxUrlByStep({
                viewingFishing,
                viewingLanding,
                viewingWeighting,
                viewingAuctioning,
                viewingTransportation,
                viewingCustomClearance,
              })}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="poppins-semi-bold-bay-of-many-15px">
                Transaction url
              </div>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="11" fill="#21427D" />
                <path
                  d="M12.5 7.7502V6.5577C12.5 5.8902 13.31 5.5527 13.7825 6.0252L17.225 9.4677C17.5175 9.7602 17.5175 10.2327 17.225 10.5252L13.7825 13.9677C13.31 14.4402 12.5 14.1102 12.5 13.4427V12.1752C8.74996 12.1752 6.12496 13.3752 4.24996 16.0002C4.99996 12.2502 7.24996 8.5002 12.5 7.7502Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        )}
      </div>
      <div className="overlap-group-container-2 poppins-bold-astronaut-14px button">
        <div
          className={clsx(
            "overlap-group2-22 passport-button",
            !submittedVesselData && "passport-disabled-button",
            viewingFishing && "passport-active-button"
          )}
          onClick={(submittedVesselData && viewFishingData) || null}
        >
          <div className="fishing-30">Fishing</div>
          <svg
            className="fishing-step-icon"
            width="46"
            height="52"
            viewBox="0 0 46 52"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_228_19368)">
              <path
                d="M27.2282 51.9995C26.9982 51.8684 26.7768 51.7226 26.5655 51.5632C26.3215 51.3625 26.1469 51.0901 26.0666 50.7846C25.9862 50.4791 26.0041 50.1561 26.1177 49.8613C26.2086 49.6252 26.3175 49.3964 26.4433 49.177C28.247 45.9275 30.0549 42.6788 31.8671 39.431C32.063 39.0825 32.0897 38.8408 31.8289 38.4974C29.5723 35.5286 27.9249 32.143 26.9814 28.5352C26.1053 25.2251 25.8232 21.7858 26.1482 18.3771C26.1571 18.2779 26.1851 18.1813 26.2182 18.0045C32.5781 20.3347 38.9215 20.3475 45.3641 17.9727C45.4137 19.1009 45.5078 20.1592 45.4989 21.2162C45.483 26.7968 43.8543 32.2538 40.8091 36.9303C40.4729 37.4586 40.1082 37.9681 39.7165 38.4567C39.4443 38.795 39.4316 39.0494 39.6478 39.431C41.4973 42.7153 43.3149 46.0161 45.1542 49.3055C45.5511 50.0152 45.677 50.7135 45.125 51.375C44.91 51.6294 44.5717 51.7909 44.2906 51.9944H43.4778C43.4561 51.969 43.4396 51.9321 43.4129 51.9219C40.9681 50.945 38.5247 49.9656 36.0735 49.0027C35.874 48.9321 35.6562 48.9321 35.4566 49.0027C32.9457 49.9898 30.4437 50.9959 27.9392 51.9982L27.2282 51.9995Z"
                fill="currentColor"
              />
              <path
                d="M8.74362 51.9998C7.99569 51.8078 7.22741 51.6755 6.50493 51.4147C2.58213 50.0003 0.0725014 46.4845 0.017806 42.3086C-0.0178095 39.6374 0.0114461 36.9662 0.00890216 34.2874C0.00890216 33.5459 0.290011 32.9569 0.983242 32.6478C1.67647 32.3388 2.30738 32.5283 2.84543 33.0358C4.4087 34.5113 5.97451 35.983 7.5276 37.4687C8.29079 38.1924 8.3315 39.1769 7.67388 39.86C7.03789 40.5202 6.05973 40.5227 5.3118 39.8409C4.65164 39.238 4.01056 38.6135 3.30334 37.9444C3.28193 38.0911 3.26793 38.2389 3.26137 38.387C3.28681 39.9923 3.19013 41.6128 3.37203 43.2015C3.72437 46.2543 6.3472 48.5884 9.39233 48.7372C12.5265 48.8911 15.3274 46.8368 16.0474 43.821C16.1819 43.2455 16.2502 42.6566 16.2509 42.0656C16.2661 36.7678 16.2509 31.4713 16.2674 26.1747C16.2674 25.8173 16.1555 25.6532 15.8337 25.4967C14.0262 24.6191 13.0353 23.1461 13.0353 21.1453C13.0277 19.1241 14.0173 17.6346 15.8464 16.7506C16.1758 16.5916 16.2712 16.4148 16.2699 16.0663C16.2598 11.3281 16.2699 6.58996 16.2585 1.85182C16.2585 1.08863 16.5129 0.486982 17.2214 0.153722C18.2708 -0.338536 19.455 0.408119 19.511 1.58725C19.5364 2.19526 19.5173 2.80581 19.5186 3.41382C19.5186 7.61137 19.5161 11.8089 19.511 16.0065C19.511 16.3881 19.5962 16.5878 19.9702 16.7697C21.7764 17.6499 22.7507 19.1343 22.7469 21.1351C22.7431 23.1359 21.7598 24.6127 19.9485 25.4917C19.6038 25.6596 19.5046 25.8427 19.5059 26.2141C19.5186 31.4946 19.5207 36.7746 19.5122 42.0542C19.5059 46.4603 16.9683 50.0499 12.8305 51.4872C12.1678 51.7174 11.4644 51.8319 10.7801 51.996L8.74362 51.9998ZM19.5059 21.144C19.5097 20.8227 19.4179 20.5076 19.2423 20.2385C19.0667 19.9695 18.8151 19.7586 18.5195 19.6328C18.2239 19.5069 17.8976 19.4717 17.5819 19.5316C17.2662 19.5915 16.9755 19.7438 16.7465 19.9692C16.5175 20.1946 16.3607 20.4829 16.2958 20.7976C16.231 21.1123 16.261 21.4391 16.3822 21.7367C16.5034 22.0342 16.7103 22.2891 16.9765 22.4689C17.2428 22.6487 17.5564 22.7454 17.8777 22.7467C18.3047 22.7451 18.7141 22.5766 19.0183 22.2771C19.3226 21.9775 19.4976 21.5709 19.5059 21.144Z"
                fill="currentColor"
              />
              <path
                d="M44.774 14.7638C38.7575 17.0788 32.7728 17.0737 26.666 14.7345C27.1112 13.3353 27.4852 11.9552 27.9914 10.6222C29.4091 6.91469 31.5823 3.5425 34.373 0.719793C35.2964 -0.225292 36.2084 -0.232923 37.123 0.701985C40.8249 4.45328 43.4328 9.14368 44.6659 14.2677C44.7015 14.4127 44.7295 14.5603 44.774 14.7638ZM39.0691 11.3612C39.066 11.1455 39.0201 10.9325 38.9342 10.7346C38.8482 10.5367 38.7238 10.3578 38.5683 10.2083C38.4127 10.0588 38.2291 9.9416 38.0279 9.86352C37.8268 9.78544 37.6122 9.74802 37.3965 9.75343C37.1855 9.75625 36.9771 9.80065 36.7832 9.8841C36.5894 9.96754 36.4139 10.0884 36.2668 10.2397C36.1197 10.3911 36.0039 10.5699 35.926 10.7661C35.8481 10.9622 35.8097 11.1718 35.8129 11.3828C35.8143 11.5963 35.8577 11.8074 35.9407 12.0041C36.0237 12.2008 36.1447 12.3792 36.2966 12.5291C36.4486 12.6791 36.6286 12.7976 36.8264 12.878C37.0241 12.9584 37.2358 12.999 37.4493 12.9976C37.6627 12.9962 37.8738 12.9528 38.0705 12.8697C38.2672 12.7867 38.4456 12.6658 38.5956 12.5139C38.7455 12.3619 38.8641 12.1819 38.9444 11.9841C39.0248 11.7864 39.0655 11.5747 39.064 11.3612H39.0691Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19368">
                <rect width="45.4989" height="52" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          className={clsx(
            "overlap-group3-3 passport-button",
            !submittedVesselData && "passport-disabled-button",
            viewingLanding && "passport-active-button"
          )}
          onClick={(submittedVesselData && viewLandingData) || null}
        >
          <div className="place-6">Landing</div>
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            xmlns="http://www.w3.org/2000/svg"
            className="landing-step-icon"
          >
            <g clip-path="url(#clip0_228_19376)">
              <path
                d="M31.4849 2.70233C31.4849 2.34342 31.4759 2.0626 31.4849 1.78328C31.5225 0.798159 32.2613 0.0127645 33.2374 0.00976112C38.0729 -0.00325371 42.9079 -0.00325371 47.7424 0.00976112C48.2004 0.012933 48.6384 0.197071 48.9611 0.522005C49.2838 0.846939 49.4649 1.2863 49.4649 1.74424C49.4829 5.37838 49.4829 9.01302 49.4649 12.6482C49.4649 13.6273 48.6765 14.3631 47.6839 14.3856C46.8069 14.4052 45.9284 14.3856 45.0138 14.3856V37.7778H45.6265C47.7459 37.7778 49.8638 37.7778 51.9803 37.7778C53.2372 37.7778 53.97 38.5106 53.9715 39.7675C53.9715 43.8322 53.9715 47.8978 53.9715 51.9644C53.9715 53.2319 53.2477 53.9647 51.9923 53.9647C44.9092 53.9647 37.8256 53.9647 30.7416 53.9647C29.5237 53.9647 28.7893 53.2139 28.7893 51.996C28.7893 47.9113 28.7893 43.8267 28.7893 39.742C28.7893 38.5226 29.5312 37.7898 30.7491 37.7793C32.47 37.7793 34.191 37.7793 35.948 37.7793V14.3916H33.6384C32.1487 14.3916 31.4864 13.7279 31.4789 12.2322V11.7381H15.3295V17.0917C15.6298 17.0917 15.9302 17.0812 16.2185 17.0917C16.6925 17.1004 17.144 17.2955 17.4752 17.6348C17.8063 17.9741 17.9904 18.4302 17.9875 18.9043C17.9864 19.3694 17.8031 19.8156 17.4769 20.1471C17.1507 20.4786 16.7076 20.6692 16.2425 20.6778C14.4065 20.7018 12.5699 20.7018 10.7328 20.6778C10.2676 20.6668 9.82527 20.4741 9.5005 20.1409C9.17573 19.8077 8.99438 19.3606 8.99529 18.8953C8.99482 18.4311 9.17351 17.9846 9.49411 17.6489C9.81472 17.3131 10.2525 17.1141 10.7163 17.0932C11.0166 17.0782 11.3169 17.0932 11.6518 17.0932V11.6946H10.9986C8.9192 11.6946 6.83934 11.6946 4.75897 11.6946C3.41794 11.6916 2.70312 10.9828 2.70312 9.65975C2.70312 8.01087 2.70312 6.362 2.70312 4.71312C2.70312 3.42465 3.42695 2.70233 4.72293 2.70233H31.4849ZM35.107 10.7575H45.8322V3.62888H35.107V10.7575Z"
                fill="currentColor"
              />
              <path
                d="M22.6023 48.9173C23.4673 48.7987 24.2903 48.6245 25.1207 48.5869C25.3603 48.5732 25.6003 48.6086 25.8257 48.691C26.0512 48.7734 26.2575 48.9009 26.4318 49.0659C26.6062 49.2309 26.745 49.4297 26.8398 49.6503C26.9345 49.8708 26.9832 50.1084 26.9828 50.3484C26.9948 51.3501 26.2109 52.0709 25.1658 52.1895C24.5365 52.2616 23.8487 52.4148 23.3277 52.7482C20.7027 54.4301 18.0897 54.331 15.4872 52.7917C14.0951 51.9688 12.8112 51.9823 11.4326 52.8263C8.8797 54.3835 6.30577 54.4151 3.76187 52.7827C3.1836 52.3942 2.50614 52.1795 1.80965 52.164C1.57085 52.165 1.33422 52.1185 1.11354 52.0273C0.892848 51.9361 0.692496 51.8019 0.524124 51.6325C0.355752 51.4632 0.22272 51.262 0.132758 51.0408C0.0427963 50.8196 -0.00229991 50.5827 9.02726e-05 50.3439C-0.000352036 50.1039 0.0483738 49.8664 0.143263 49.646C0.238152 49.4256 0.377193 49.2269 0.55181 49.0623C0.726427 48.8976 0.932919 48.7705 1.15855 48.6888C1.38418 48.607 1.62417 48.5724 1.86371 48.5869C2.69416 48.6245 3.51559 48.7987 4.38208 48.9173C4.27246 48.5103 4.15232 48.0493 4.02167 47.5898C3.33289 45.181 2.6431 42.7723 1.95231 40.3636C1.57989 39.0586 2.00638 38.2386 3.28884 37.7776C4.09826 37.4878 4.89717 37.1634 5.7156 36.9036C6.1541 36.7655 6.31628 36.5672 6.31628 36.0822C6.28625 33.741 6.30127 31.3984 6.30277 29.0557C6.30277 27.6891 7.01007 26.9863 8.38414 26.9863H18.6153C19.9909 26.9863 20.6937 27.6861 20.6952 29.0557C20.6952 31.3788 20.7117 33.711 20.6831 36.0251C20.6831 36.5102 20.7883 36.7565 21.2838 36.9021C22.1068 37.1469 22.9042 37.4788 23.7106 37.7776C25.0261 38.2627 25.4165 39.0511 25.0261 40.4161C24.2392 43.1673 23.4538 45.9204 22.6699 48.6755C22.6339 48.7581 22.6173 48.8497 22.6023 48.9173ZM9.9264 35.3629C10.6773 35.0896 11.4161 34.8748 12.1054 34.5595C12.5412 34.3446 13.0206 34.2329 13.5065 34.2329C13.9924 34.2329 14.4718 34.3446 14.9076 34.5595C15.5908 34.8733 16.3222 35.0836 17.0595 35.3494V30.6175H9.89336C9.89336 32.0891 9.89336 33.5263 9.89336 34.9634C9.89486 35.0715 9.91138 35.1797 9.9264 35.3629Z"
                fill="currentColor"
              />
              <path
                d="M40.4695 8.99548C39.8688 8.99548 39.2682 9.009 38.6675 8.99548C38.1953 8.99077 37.7438 8.80089 37.4101 8.46669C37.0765 8.13249 36.8874 7.68067 36.8834 7.20845C36.8805 6.97299 36.9242 6.73929 37.0122 6.52088C37.1002 6.30247 37.2307 6.10369 37.3961 5.93608C37.5615 5.76846 37.7585 5.63533 37.9757 5.54441C38.1929 5.45348 38.426 5.40657 38.6615 5.40639C39.8799 5.38537 41.0972 5.38537 42.3136 5.40639C42.7801 5.41867 43.2233 5.61229 43.5493 5.94612C43.8753 6.27996 44.0583 6.72771 44.0595 7.19431C44.0607 7.6609 43.8799 8.10957 43.5556 8.44504C43.2313 8.78051 42.789 8.97635 42.3226 8.99098C41.7054 9.0105 41.0867 8.99398 40.4695 8.99548Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19376">
                <rect width="53.9745" height="54" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div className="overlap-group-container-3 poppins-bold-astronaut-14px">
        <div
          className={clsx(
            "overlap-group4-7 passport-button",
            !submittedLotData && "passport-disabled-button",
            viewingWeighting && "passport-active-button"
          )}
          onClick={(submittedLotData && viewWeightingData) || null}
        >
          <div className="weighting">Weighting</div>
          <svg
            width="45"
            height="52"
            viewBox="0 0 45 52"
            xmlns="http://www.w3.org/2000/svg"
            className="weighting-step-icon"
          >
            <g clip-path="url(#clip0_228_19384)">
              <path
                d="M39.3342 52H5.20378C5.16623 51.9673 5.12317 51.9414 5.07661 51.9237C1.98621 51.2636 0.236262 48.9528 0.547845 45.8256C0.779307 43.5033 1.10742 41.1925 1.39103 38.8766C1.81495 35.4183 2.23887 31.9608 2.66279 28.5041C2.99727 25.7851 3.29868 23.0622 3.68021 20.3495C4.06174 17.6152 6.08003 15.7546 8.83086 15.644C11.1289 15.5524 13.4334 15.6122 15.734 15.6046H16.3419V11.6303C16.2033 11.6125 16.0876 11.5934 15.9744 11.5833C11.2688 11.1763 7.07201 9.52935 3.52378 6.36901C2.24444 5.2322 1.14689 3.90603 0.269328 2.43671C-0.421241 1.28576 0.282046 0.0406965 1.62885 0C1.74712 0 1.86667 0 1.98494 0H42.5543C42.6904 0 42.8265 0 42.9613 0C44.247 0.0534142 44.9541 1.28957 44.2852 2.38583C43.8313 3.13926 43.3211 3.85731 42.7591 4.53385C39.8823 7.96508 36.1815 10.047 31.86 11.0644C30.6658 11.3442 29.4373 11.4841 28.1922 11.7003V15.6122H28.7518C30.9011 15.6122 33.0504 15.6122 35.1997 15.6122C38.2964 15.6249 40.4572 17.4436 40.8743 20.506C41.383 24.2755 41.8154 28.0564 42.2796 31.8323C42.8404 36.3967 43.3886 40.9636 43.9647 45.5267C44.2381 47.6951 43.6353 49.501 41.907 50.8885C41.1515 51.4926 40.2486 51.7609 39.3342 52ZM22.2556 46.5009C29.2097 46.5263 34.9504 40.797 34.9733 33.815C34.9962 26.833 29.2885 21.1317 22.2938 21.1164C15.2991 21.1012 9.59901 26.7949 9.57612 33.7845C9.55577 40.7474 15.2673 46.4754 22.2556 46.5009Z"
                fill="currentColor"
              />
              <path
                d="M22.2623 24.1992C27.5313 24.1891 31.8451 28.5004 31.8604 33.7934C31.8756 39.0865 27.572 43.3775 22.2763 43.3838C19.7514 43.3567 17.3389 42.335 15.5624 40.5406C13.7858 38.7461 12.7885 36.3236 12.7866 33.7985C12.7848 31.2733 13.7786 28.8493 15.5526 27.0523C17.3265 25.2552 19.7374 24.2301 22.2623 24.1992V24.1992ZM23.8215 34.0185C23.777 33.1283 23.4769 32.64 22.8741 32.3907C22.2382 32.1249 21.6404 32.2483 21.147 32.7379C19.9363 33.941 18.7285 35.1496 17.5237 36.3637C16.8332 37.0632 16.8154 37.9877 17.4512 38.6223C18.0871 39.257 19.0066 39.2392 19.7137 38.5422C20.9193 37.3557 22.1301 36.1678 23.2925 34.9457C23.5761 34.6493 23.7147 34.2106 23.8215 34.0185Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19384">
                <rect width="44.5424" height="52" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          className={clsx(
            "overlap-group5-4 passport-button",
            !submittedSalesNoteData && "passport-disabled-button",
            viewingAuctioning && "passport-active-button"
          )}
          onClick={(submittedSalesNoteData && viewAuctioningData) || null}
        >
          <div className="auctioning">Auctioning</div>
          <svg
            className="auctioning-step-icon"
            width="53"
            height="53"
            viewBox="0 0 53 53"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_228_19391)">
              <path
                d="M0 50.2328C0.388029 49.3812 1.05419 49.0239 1.98899 49.1179C2.37295 49.1528 2.76369 49.1179 3.12187 49.1179C3.39322 48.4328 3.59131 47.7491 3.92778 47.1446C5.389 44.5224 7.65205 43.1254 10.6844 43.0945C14.6949 43.0542 18.7055 43.0797 22.7174 43.0864C26.3738 43.0864 29.284 45.3056 30.2487 48.8022C30.2704 48.8828 30.2894 48.9634 30.326 49.1179H31.7682C32.7179 49.1179 33.3298 49.5491 33.4981 50.3403C33.6541 51.0724 33.2348 51.7253 32.3842 52.0786C32.3548 52.095 32.3279 52.1153 32.3041 52.139H1.22107C0.647168 51.9509 0.271349 51.5493 0 51.0321V50.2328Z"
                fill="currentColor"
              />
              <path
                d="M0 24.4944L0.191301 23.9826C0.35488 23.5358 0.623043 23.1338 0.973816 22.8095C1.32459 22.4852 1.74799 22.2477 2.20932 22.1167C2.67065 21.9856 3.15678 21.9646 3.62788 22.0555C4.09897 22.1463 4.54162 22.3464 4.91956 22.6393C5.07866 22.764 5.22956 22.8986 5.37136 23.0423C9.57456 27.1994 13.7759 31.3587 17.9755 35.5203C19.1545 36.6876 19.3526 38.2459 18.5033 39.4911C18.2635 39.8427 17.9515 40.1403 17.5878 40.3645C17.2241 40.5887 16.8167 40.7345 16.3922 40.7924C15.9678 40.8503 15.5357 40.8191 15.1243 40.7006C14.7129 40.5822 14.3313 40.3792 14.0043 40.105C13.927 40.0405 13.8537 39.9707 13.7818 39.8995C9.49722 35.6654 5.20176 31.4326 0.940225 27.1662C0.522347 26.7471 0.309338 26.1279 0 25.5999V24.4944Z"
                fill="currentColor"
              />
              <path
                d="M46.8306 52.15C45.022 51.8491 43.9204 50.5689 42.8024 49.3076C42.569 49.0389 42.3248 48.789 42.124 48.5741C44.2812 46.4369 46.4249 44.3145 48.5903 42.1719C49.3758 43.0262 50.2781 43.894 51.0473 44.8666C53.1096 47.478 51.6891 51.2997 48.422 52.0358C48.2945 52.064 48.171 52.111 48.0462 52.15H46.8306Z"
                fill="currentColor"
              />
              <path
                d="M20.2982 8.09961L33.0814 20.755L20.2833 33.4211L7.5 20.7684L20.2982 8.09961Z"
                fill="currentColor"
              />
              <path
                d="M46.3246 39.8965C44.1361 42.0619 42.0074 44.1669 39.8475 46.3054C39.1582 45.6405 38.4459 44.9621 37.7377 44.2676C35.1626 41.7699 32.5902 39.27 30.0205 36.7679C29.9245 36.6557 29.8004 36.5704 29.6607 36.5204C29.5209 36.4705 29.3704 36.4576 29.2241 36.4831C28.6257 36.5722 28.0141 36.4738 27.475 36.2016C26.9358 35.9294 26.4962 35.4971 26.2176 34.9652C25.6423 33.8905 25.74 32.5002 26.5798 31.6311C28.1175 30.046 29.685 28.494 31.2823 26.9751C32.1411 26.1611 33.5413 26.0577 34.6063 26.603C35.1413 26.8652 35.5806 27.2856 35.8636 27.8059C36.1465 28.3262 36.2591 28.9208 36.1856 29.5073C36.1554 29.6755 36.17 29.8486 36.2281 30.0095C36.2862 30.1705 36.3856 30.3136 36.5166 30.4248C39.6453 33.4392 42.7658 36.4616 45.8782 39.4921C46.0261 39.6332 46.1794 39.7635 46.3246 39.8965Z"
                fill="currentColor"
              />
              <path
                d="M40.5574 16.8603C40.5262 17.7106 39.9821 18.6469 38.8615 19.1842C37.7666 19.7094 36.6907 19.5966 35.7002 18.8887C35.5374 18.7664 35.3845 18.6317 35.243 18.4857C31.0136 14.3062 26.7878 10.1245 22.5656 5.94049C21.0162 4.40239 21.2753 2.10533 23.1083 1.06426C24.3022 0.383202 25.7512 0.579326 26.7919 1.59218C28.0835 2.84952 29.3575 4.12433 30.6382 5.39242C33.5959 8.31994 36.5541 11.2461 39.5127 14.171C40.1599 14.8158 40.5669 15.5505 40.5574 16.8603Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19391">
                <rect
                  width="52.0149"
                  height="51.4851"
                  fill="white"
                  transform="translate(0 0.664062)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div className="overlap-group-container-4 poppins-bold-astronaut-14px">
        <div
          className={clsx(
            "overlap-group6-4 passport-button",
            !submittedTransportDocData && "passport-disabled-button",
            viewingTransportation && "passport-active-button"
          )}
          onClick={
            (submittedTransportDocData && viewTransportationData) || null
          }
        >
          <div className="transportation">Transportation</div>
          <svg
            width="71"
            height="44"
            viewBox="0 0 71 44"
            xmlns="http://www.w3.org/2000/svg"
            className="transport-step-icon"
          >
            <g clip-path="url(#clip0_228_19402)">
              <path
                d="M70.4055 34.3782C70.0817 35.4391 69.6752 36.4449 68.7521 37.1572C68.0053 37.7332 67.1842 38.0955 66.2294 38.0997C64.948 38.0997 63.668 38.0997 62.333 38.0997C61.8094 34.837 60.1367 32.43 56.9788 31.3043C53.8209 30.1787 50.995 30.9709 48.4627 33.2333C48.4341 33.0604 48.4148 32.886 48.4048 32.7111C48.4048 25.3095 48.4048 17.9071 48.4048 10.5037C48.4048 9.35188 48.9407 8.80076 50.0761 8.79801C52.9405 8.79801 55.8063 8.76494 58.6708 8.8049C61.188 8.84072 63.0632 9.99394 64.1282 12.2976C66.0369 16.431 67.9199 20.5763 69.7772 24.7336C70.0528 25.3509 70.2016 26.0246 70.4082 26.6722L70.4055 34.3782ZM58.2698 23.4936C59.7854 23.4936 61.2927 23.5129 62.8042 23.4936C64.2288 23.4702 64.8709 22.4492 64.2867 21.1514C63.5826 19.5875 62.8648 18.0306 62.1511 16.4668C61.6096 15.2819 60.6782 14.6977 59.3817 14.6936C57.5038 14.6936 55.6258 14.6853 53.7479 14.6936C52.5905 14.6936 52.0945 15.2103 52.0849 16.3842C52.0766 18.1468 52.0766 19.91 52.0849 21.6735C52.0849 22.9549 52.636 23.4853 53.9435 23.4895C55.3875 23.495 56.8259 23.4909 58.2684 23.4909L58.2698 23.4936Z"
                fill="currentColor"
              />
              <path
                d="M2.91944 22.0034V21.1106C2.91944 15.6812 2.91944 10.2517 2.91944 4.8223C2.91944 2.42217 4.07817 0.775701 6.211 0.166714C6.67723 0.0482727 7.15753 -0.00550572 7.6384 0.00688899C18.6819 0.00229633 29.7241 0 40.7648 0C43.6237 0 45.4672 1.85314 45.4755 4.75754C45.4907 10.4837 45.4755 16.2112 45.4755 21.9387C45.4755 24.2525 45.4755 26.5663 45.4755 28.88C45.4755 30.3129 44.9712 30.809 43.5273 30.809H2.02112C0.717721 30.8034 0.0191769 30.3116 -0.000112261 29.3692C-0.0194014 28.4267 0.703943 27.8949 2.05281 27.8922C2.99109 27.8922 3.93075 27.9004 4.87041 27.8922C5.91478 27.8798 6.58577 27.3052 6.59679 26.4276C6.60781 25.5499 5.93544 24.9382 4.89658 24.9202C3.82052 24.8954 2.74309 24.9202 1.66565 24.9106C0.665365 24.9023 -0.000112261 24.3264 -0.000112261 23.4791C-0.000112261 22.6317 0.65572 22.0448 1.65325 22.0048C2.0349 21.9924 2.42344 22.0034 2.91944 22.0034Z"
                fill="currentColor"
              />
              <path
                d="M22.3936 33.7129H33.4587C36.8242 33.7129 40.1897 33.7129 43.5552 33.7129C44.9399 33.7129 45.4703 34.2433 45.4841 35.6156C45.4992 37.8422 45.2333 38.1122 43.0275 38.1122C36.9831 38.1122 30.94 38.1053 24.8956 38.1246C24.3307 38.1246 24.1709 37.9689 24.0138 37.4068C23.7245 36.3652 23.2354 35.3786 22.8138 34.3756C22.691 34.1442 22.5505 33.9226 22.3936 33.7129V33.7129Z"
                fill="currentColor"
              />
              <path
                d="M59.3998 38.8319C59.4205 41.6192 57.1361 43.9435 54.3226 43.9972C51.5339 44.051 49.1421 41.6881 49.1338 38.8705C49.1242 36.1149 51.4678 33.7547 54.2496 33.723C56.9969 33.6899 59.3833 36.0529 59.3998 38.8319Z"
                fill="currentColor"
              />
              <path
                d="M21.2663 38.878C21.2513 40.2322 20.7066 41.5267 19.7488 42.4841C18.7911 43.4416 17.4965 43.986 16.1423 44.0007C13.333 44.0117 10.9783 41.6405 11.0031 38.8271C11.0279 36.0439 13.4156 33.6824 16.1602 33.7292C18.9503 33.7664 21.2801 36.1183 21.2663 38.878Z"
                fill="currentColor"
              />
              <path
                d="M3.03113 33.7559H9.64456L7.87684 38.0766C5.31276 38.4638 2.82859 36.364 3.03113 33.7559Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19402">
                <rect width="70.4041" height="44" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div
          className={clsx(
            "overlap-group7-4 passport-button",
            (!submittedCatchCertificateData ||
              !submittedHealthCertificateData) &&
              "passport-disabled-button",
            viewingCustomClearance && "passport-active-button"
          )}
          onClick={
            (submittedCatchCertificateData &&
              submittedHealthCertificateData &&
              viewCustomClearanceData) ||
            null
          }
        >
          <div className="custom-clearance">Custom clearance</div>
          <svg
            width="43"
            height="50"
            viewBox="0 0 43 50"
            xmlns="http://www.w3.org/2000/svg"
            className="custom-cl-step-icon"
          >
            <g clip-path="url(#clip0_228_19413)">
              <path
                d="M38.1234 23.2749L15.4563 49.9951V32.1681C14.8605 32.2936 14.354 32.3942 13.8498 32.5073C10.8255 33.1777 7.80456 33.864 4.77799 34.5174C2.24097 35.0658 0.0216351 33.3009 0.0125904 30.7029C-0.00549889 25.5896 -0.00549889 20.4756 0.0125904 15.3609C0.0193739 13.198 1.70846 11.4943 3.80682 11.4671C5.95493 11.44 7.67115 13.0918 7.6949 15.3032C7.73108 18.6113 7.70733 21.9205 7.70846 25.2297V25.9714C8.8187 25.7385 9.843 25.5304 10.8639 25.31C14.2044 24.5909 17.5445 23.8707 20.8843 23.1494C21.1228 23.1017 21.3657 23.0794 21.609 23.0827C26.4607 23.0827 31.3113 23.0846 36.1607 23.0884C36.7678 23.0895 37.3738 23.2003 38.1234 23.2749Z"
                fill="currentColor"
              />
              <path
                d="M20.8911 50.0009C27.7515 41.915 34.5474 33.9037 41.3874 25.8438C41.9199 26.5549 42.1642 27.3305 42.2998 28.1411C42.362 28.5503 42.3904 28.964 42.3846 29.3779C42.3891 36.0529 42.3891 42.7282 42.3846 49.404V50.0009H20.8911Z"
                fill="currentColor"
              />
              <path
                d="M19.28 5.76613C19.531 5.75596 19.7142 5.74013 19.8973 5.74013C25.8894 5.74013 31.8815 5.74578 37.8792 5.72656C38.4016 5.72656 38.5576 5.86675 38.535 6.38456C38.4592 8.33482 38.535 10.2986 38.3281 12.2331C38.1935 13.4767 37.7933 14.7384 37.2812 15.8894C35.4632 19.9753 31.9674 21.4213 27.9505 21.1115C23.0641 20.7339 20.5644 17.436 19.6588 13.3535C19.4441 12.3069 19.3223 11.2434 19.2947 10.1754C19.2348 8.71356 19.28 7.25285 19.28 5.76613Z"
                fill="currentColor"
              />
              <path
                d="M40.4364 0C39.8146 1.24364 39.2334 2.43301 38.6105 3.60317C38.5404 3.73544 38.2363 3.79876 38.0452 3.79989C36.0723 3.81345 34.0983 3.80893 32.1255 3.80893C28.0282 3.80893 23.931 3.80215 19.8349 3.81798C19.4245 3.81798 19.1995 3.71396 19.0198 3.32617C18.502 2.22386 17.9378 1.14528 17.3657 0H40.4364Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_228_19413">
                <rect width="42.3878" height="50" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </>
  );
};

export default PassportInfo;
